module.exports = __webpack_public_path__ + "img/turkey.ffeaeaa6.svg";